export enum TrKey {
  // Generic
  name = 'name',
  emailAddress = 'emailAddress',
  cancel = 'cancel',
  save = 'save',
  saving = 'saving',
  list = 'list',
  grid = 'grid',
  add = 'add',
  delete = 'delete',
  remove = 'remove',
  edit = 'edit',
  create = 'create',
  title = 'title',
  date = 'date',
  summary = 'summary',
  image = 'image',
  breadText = 'breadText',
  publish = 'publish',
  day = 'day',
  week = 'week',
  size = 'size',
  type = 'type',
  select = 'select',
  close = 'close',
  done = 'done',
  somethingWentWrong = 'somethingWentWrong',
  new = 'new',

  // Weekdays
  weekdayMondayPlural = 'weekdayMondayPlural',
  weekdayTuesdayPlural = 'weekdayTuesdayPlural',
  weekdayWednesdayPlural = 'weekdayWednesdayPlural',
  weekdayThursdayPlural = 'weekdayThursdayPlural',
  weekdayFridayPlural = 'weekdayFridayPlural',
  weekdaySaturdayPlural = 'weekdaySaturdayPlural',
  weekdaySundayPlural = 'weekdaySundayPlural',

  // Navbar
  navbarItemUsers = 'navbarItemUsers',
  navbarItemCourses = 'navbarItemCourses',
  navbarItemBlog = 'navbarItemBlog',
  navbarItemCalendar = 'navbarItemCalendar',
  navbarItemSponsors = 'navbarItemSponsors',
  navbarItemDashboard = 'navbarItemDashboard',
  navbarItemMedia = 'navbarItemMedia',
  navbarItemAdministrators = 'navbarItemAdministrators',
  navbarItemAccount = 'navbarItemAccount',
  navbarItemLogout = 'navbarItemLogout',
  navbarMenu = 'navbarMenu',
  navbarItemECommerce = 'navbarItemECommerce',

  // Dashboard
  dashboardWebsite = 'dashboardWebsite',
  freeTierBannerText = 'freeTierBannerText',
  editWebsite = 'editWebsite',
  showLiveWebsite = 'showLiveWebsite',
  deployStatusBuilding = 'deployStatusBuilding',
  deployStatusReady = 'deployStatusReady',
  deployStatusError = 'deployStatusError',
  deployStatusPending = 'deployStatusPending',

  // Account
  accountSettings = 'accountSettings',
  accountUpdateDisclaimer = 'accountUpdateDisclaimer',
  accountChangePassword = 'accountChangePassword',
  accountUpdateInfo = 'accountUpdateInfo',
  accountNameDescription = 'accountNameDescription',
  accountNamePlaceholder = 'accountNamePlaceholder',
  accountEmailDescription = 'accountEmailDescription',
  accountCurrentPassword = 'accountCurrentPassword',
  accountNewPassword = 'accountNewPassword',
  accountNewPasswordRepeat = 'accountNewPasswordRepeat',
  accountCurrentPasswordDescription = 'accountCurrentPasswordDescription',
  accountNewPasswordDescription = 'accountNewPasswordDescription',
  accountNewPasswordRepeatDescription = 'accountNewPasswordRepeatDescription',
  accountPasswordRequirements = 'accountPasswordRequirements',
  accountPasswordRequirementsItem1 = 'accountPasswordRequirementsItem1',
  accountPasswordRequirementsItem2 = 'accountPasswordRequirementsItem2',
  accountPasswordRequirementsItem3 = 'accountPasswordRequirementsItem3',
  accountPasswordRequirementsItem4 = 'accountPasswordRequirementsItem4',
  accountFailedToUpdatePassword = 'accountFailedToUpdatePassword',
  accountCheckPasswords = 'accountCheckPasswords',
  accountSignInAgain = 'accountSignInAgain',
  accountPasswordUpdated = 'accountPasswordUpdated',
  accountPasswordsDoNotMatch = 'accountPasswordsDoNotMatch',
  accountFailedToUpdateInfo = 'accountFailedToUpdateInfo',
  accountUpdatedInfo = 'accountUpdatedInfo',

  // Sponsors
  sponsor = 'sponsor',
  sponsors = 'sponsors',
  sponsorsSearchPlaceholder = 'sponsorsSearchPlaceholder',
  sponsorsNoSponsorsFound = 'sponsorsNoSponsorsFound',
  sponsorsFailedToSave = 'sponsorsFailedToSave',
  sponsorSaved = 'sponsorSaved',
  sponsorUpdated = 'sponsorUpdated',
  theSponsor = 'theSponsor',
  sponsorsFailedToDelete = 'sponsorsFailedToDelete',
  sponsorDeleted = 'sponsorDeleted',
  sponsorName = 'sponsorName',
  sponsorNameDescription = 'sponsorNameDescription',
  sponsorUrl = 'sponsorUrl',
  sponsorUrlDescription = 'sponsorUrlDescription',
  sponsorUrlPlaceholder = 'sponsorUrlPlaceholder',
  sponsorLogo = 'sponsorLogo',
  sponsorLogoDescription = 'sponsorLogoDescription',

  // Blog
  blogCouldNotSavePost = 'blogCouldNotSavePost',
  blogPostUpdated = 'blogPostUpdated',
  blogPostDuplicateTitle = 'blogPostDuplicateTitle',
  blogPostSaved = 'blogPostSaved',
  theBlogPost = 'theBlogPost',
  blogCouldNotDeletePost = 'blogCouldNotDeletePost',
  blogPostDeleted = 'blogPostDeleted',
  blogMissingWebsite = 'blogMissingWebsite',
  blogTitle = 'blogTitle',
  blogCreatePost = 'blogCreatePost',
  blogSearchPosts = 'blogSearchPosts',
  blogNoPostsFound = 'blogNoPostsFound',
  blogPost = 'blogPost',
  blogPostTitleDescription = 'blogPostTitleDescription',
  blogPostTitlePlaceholder = 'blogPostTitlePlaceholder',
  blogPostDateDescription = 'blogPostDateDescription',
  blogPostDatePlaceholder = 'blogPostDatePlaceholder',
  blogPostSummaryDescription = 'blogPostSummaryDescription',
  blogPostSummaryPlaceholder = 'blogPostSummaryPlaceholder',
  blogPostImageDescription = 'blogPostImageDescription',
  blogPostBreadTextDescription = 'blogPostBreadTextDescription',
  blogPostDelayPublishing = 'blogPostDelayPublishing',
  blogPostDelayPublishingUntil = 'blogPostDelayPublishingUntil',
  blogPostRemoveDelayedPublishing = 'blogPostRemoveDelayedPublishing',

  // Calendar
  calendarCouldNotSaveEvent = 'calendarCouldNotSaveEvent',
  calendarEventSaved = 'calendarEventSaved',
  calendarTheEvent = 'calendarTheEvent',
  calendarCouldNotDeleteEvent = 'calendarCouldNotDeleteEvent',
  calendarEventDeleted = 'calendarEventDeleted',
  calendarCouldNotUpdateEvent = 'calendarCouldNotUpdateEvent',
  calendarEventUpdated = 'calendarEventUpdated',
  calendarRepeatStringDay = 'calendarRepeatStringDay',
  calendarRepeatStringWeek = 'calendarRepeatStringWeek',
  calendarTitle = 'calendarTitle',
  calendarCreateEvent = 'calendarCreateEvent',
  calendarNoEventsFound = 'calendarNoEventsFound',
  calendarEndTimeBeforeStartTime = 'calendarEndTimeBeforeStartTime',
  calendarEvent = 'calendarEvent',
  calendarEventSummaryLabel = 'calendarEventSummaryLabel',
  calendarEventSummaryDescription = 'calendarEventSummaryDescription',
  calendarEventStartTimeLabel = 'calendarEventStartTimeLabel',
  calendarEventStartTimeDescription = 'calendarEventStartTimeDescription',
  calendarEventEndTimeLabel = 'calendarEventEndTimeLabel',
  calendarEventEndTimeDescription = 'calendarEventEndTimeDescription',
  calendarEventRepeatOptionsLabel = 'calendarEventRepeatOptionsLabel',
  calendarEventRepeatOptionsDescription = 'calendarEventRepeatOptionsDescription',
  calendarEventRepeatEvery = 'calendarEventRepeatEvery',
  calendarRepeatOptionsUntil = 'calendarRepeatOptionsUntil',
  calendarRepeatOptionsCancelledDatesLabel = 'calendarRepeatOptionsCancelledDatesLabel',
  calendarRepeatOptionsCancelledDatesDescription = 'calendarRepeatOptionsCancelledDatesDescription',
  calendarRepeatOptionsCancelledDatesPlaceholder = 'calendarRepeatOptionsCancelledDatesPlaceholder',
  calendarLocationNameLabel = 'calendarLocationNameLabel',
  calendarLocationNameDescription = 'calendarLocationNameDescription',
  calendarLocationAddressLabel = 'calendarLocationAddressLabel',
  calendarLocationAddressDescription = 'calendarLocationAddressDescription',
  calendarBreadTextDescription = 'calendarBreadTextDescription',

  // Media
  mediaRouteTitle = 'mediaRouteTitle',
  mediaTypeAll = 'mediaTypeAll',
  mediaTypeImage = 'mediaTypeImage',
  mediaTypeVideo = 'mediaTypeVideo',
  mediaTypePdf = 'mediaTypePdf',
  mediaFailedToFetchFiles = 'mediaFailedToFetchFiles',
  mediaNoFilesFound = 'mediaNoFilesFound',
  mediaTheFile = 'mediaTheFile',
  mediaCouldNotDeleteFile = 'mediaCouldNotDeleteFile',
  mediaFileDeleted = 'mediaFileDeleted',
  mediaUsageQuota = 'mediaUsageQuota',
  mediaSearchFileName = 'mediaSearchFileName',
  mediaUploadedAt = 'mediaUploadedAt',
  mediaUsed = 'mediaUsed',
  mediaUsedIn = 'mediaUsedIn',
  mediaFileTooLarge = 'mediaFileTooLarge',
  mediaInvalidFile = 'mediaInvalidFile',
  mediaFilesUploaded = 'mediaFilesUploaded',
  mediaUploadError = 'mediaUploadError',
  mediaDropImages = 'mediaDropImages',
  mediaDragNDrop = 'mediaDragNDrop',
  mediaMaxFileSize = 'mediaMaxFileSize',
  mediaUploading = 'mediaUploading',

  // Courses
  coursesRouteTitle = 'coursesRouteTitle',
  createCourse = 'createCourse',
  theCourse = 'theCourse',
  coursesFailedToDelete = 'coursesFailedToDelete',
  coursesCourseDeleted = 'coursesCourseDeleted',
  coursesFailedToCreate = 'coursesFailedToCreate',
  coursesCourseCreated = 'coursesCourseCreated',
  courseNameDescription = 'courseNameDescription',
  courseNamePlaceholder = 'courseNamePlaceholder',
  courseLastUpdated = 'courseLastUpdated',
  coursePublished = 'coursePublished',
  courseNotPublished = 'courseNotPublished',

  // Users
  usersRouteTitle = 'usersRouteTitle',
  usersCreateUser = 'usersCreateUser',
  usersTheUser = 'usersTheUser',
  usersFailedToDelete = 'usersFailedToDelete',
  usersUserDeleted = 'usersUserDeleted',
  usersFailedToCreate = 'usersFailedToCreate',
  usersUserCreated = 'usersUserCreated',
  usersFailedToUpdate = 'usersFailedToUpdate',
  usersUserUpdated = 'usersUserUpdated',
  usersLastLogin = 'usersLastLogin',
  usersFullNameDescription = 'usersFullNameDescription',
  usersFullNamePlaceholder = 'usersFullNamePlaceholder',
  usersEmailDescription = 'usersEmailDescription',
  usersYou = 'usersYou',

  // CustomerUsers
  customerUsersRouteTitle = 'customerUsersRouteTitle',
  customerUsersCreateUser = 'customerUsersCreateUser',
  customerUsersTheUser = 'customerUsersTheUser',
  customerUsersFailedToDelete = 'customerUsersFailedToDelete',
  customerUsersUserDeleted = 'customerUsersUserDeleted',
  customerUsersFailedToCreate = 'customerUsersFailedToCreate',
  customerUsersUserCreated = 'customerUsersUserCreated',
  customerUsersFailedToUpdate = 'customerUsersFailedToUpdate',
  customerUsersUserUpdated = 'customerUsersUserUpdated',
  customerUsersFullNameDescription = 'customerUsersFullNameDescription',
  customerUsersFillNamePlaceholder = 'customerUsersFillNamePlaceholder',
  customerUsersEmailDescription = 'customerUsersEmailDescription',

  // Login
  loginTitle = 'loginTitle',
  loginEmailLabel = 'loginEmailLabel',
  loginPasswordLabel = 'loginPasswordLabel',
  loginForgotPassword = 'loginForgotPassword',
  loginLoggingIn = 'loginLoggingIn',
  loginGenericError = 'loginGenericError',

  // Website analytics
  analyticsTitle = 'analyticsTitle',
  analyticsPeriod = 'analyticsPeriod',
  analyticsPeriodLastWeek = 'analyticsPeriodLastWeek',
  analyticsPeriodLast2Weeks = 'analyticsPeriodLast2Weeks',
  analyticsPeriodLast30Days = 'analyticsPeriodLast30Days',
  analyticsOverview = 'analyticsOverview',

  // Website analytics single value
  analyticsTotalPageViews = 'analyticsTotalPageViews',
  analyticsUniqueUsers = 'analyticsUniqueUsers',
  analyticsAvgEngagementTime = 'analyticsAvgEngagementTime',
  analyticsPageViewsLast5Minutes = 'analyticsPageViewsLast5Minutes',
  analyticsUniqueUsersLast5Minutes = 'analyticsUniqueUsersLast5Minutes',

  // Website analytics graph
  analyticsUniqueUsersOverTime = 'analyticsUniqueUsersOverTime',
  analyticsUsersPerRoute = 'analyticsUsersPerRoute',
  analyticsUsersPerReferer = 'analyticsUsersPerReferer',
  analyticsUsersPerDevice = 'analyticsUsersPerDevice',
  analyticsUsersPerPlatform = 'analyticsUsersPerPlatform',
  analyticsUsersPerOS = 'analyticsUsersPerOS',
  analyticsUsersPerVendor = 'analyticsUsersPerVendor',
  analyticsUsersPerCountry = 'analyticsUsersPerCountry',
  analyticsAvgEngagementTimeOverTime = 'analyticsAvgEngagementTimeOverTime',
  analyticsAvgEngagementTimePerRoute = 'analyticsAvgEngagementTimePerRoute',

  // Delete confirmation
  deleteConfirmationText = 'deleteConfirmationText',
  deleteConfirmationMismatch = 'deleteConfirmationMismatch',

  // Confirm provider
  confirmProviderDefaultTitle = 'confirmProviderDefaultTitle',
  confirmProviderDefaultProceed = 'confirmProviderDefaultProceed',

  // Media input
  mediaInputSelectMedia = 'mediaInputSelectMedia',
  mediaInputChangeMedia = 'mediaInputChangeMedia',
  mediaInputRemoveMedia = 'mediaInputRemoveMedia',
  imageInputSelectImage = 'imageInputSelectImage',
  imageInputChangeImage = 'imageInputChangeImage',
  imageInputRemoveImage = 'imageInputRemoveImage',

  // Editor
  editorHaveYouSaved = 'editorHaveYouSaved',
  editorRouteTitle = 'editorRouteTitle',
  editorBackToOverview = 'editorBackToOverview',
  editorTabContent = 'editorTabContent',
  editorTabSettings = 'editorTabSettings',
  editorTabSitemap = 'editorTabSitemap',
  editorShowMenu = 'editorShowMenu',
  editorHideMenu = 'editorHideMenu',
  editorStaticComponents = 'editorStaticComponents',
  editorStaticComponentsTooltip = 'editorStaticComponentsTooltip',
  editorAdd = 'editorAdd',
  editorDynamicComponents = 'editorDynamicComponents',
  editorDynamicComponentsTooltip = 'editorDynamicComponentsTooltip',
  editorLeftColorsTitle = 'editorLeftColorTitle',
  editorLeftBaseColorLabel = 'editorLeftBaseColorLabel',
  editorLeftBaseColorDescription = 'editorLeftBaseColorDescription',
  editorLeftBaseColorPlaceholder = 'editorLeftBaseColorPlaceholder',
  editorLeftAccentColorLabel = 'editorLeftAccentColorLabel',
  editorLeftAccentColorDescription = 'editorLeftAccentColorDescription',
  editorLeftAccentColorPlaceholder = 'editorLeftAccentColorPlaceholder',
  editorLeftLogoTitle = 'editorLeftLogoTitle',
  editorLeftLogoWideLabel = 'editorLeftLogoWideLabel',
  editorLeftLogoWideDescription = 'editorLeftLogoWideDescription',
  editorLeftLogoSquareLabel = 'editorLeftLogoSquareLabel',
  editorLeftLogoSquareDescription = 'editorLeftLogoSquareDescription',
  editorLeftContactTitle = 'editorLeftContactTitle',
  editorLeftContactRecipientLabel = 'editorLeftContactRecipientLabel',
  editorLeftContactAdressLabel = 'editorLeftContactAdressLabel',
  editorLeftContactPostalCodeLabel = 'editorLeftContactPostalCodeLabel',
  editorLeftContactPostalAreaLabel = 'editorLeftContactPostalAreaLabel',
  editorLeftContactPhoneLabel = 'editorLeftContactPhoneLabel',
  editorLeftContactEmailLabel = 'editorLeftContactEmailLabel',
  editorLeftNavBackgroundLabel = 'editorLeftNavBackgroundLabel',
  editorLeftNavBackgroundDescription = 'editorLeftNavBackgroundDescription',
  editorLeftSocialTitle = 'editorLeftSocialTitle',
  editorLeftContactFooterTextLabel = 'editorLeftContactFooterTextLabel',
  editorLeftContactFooterImageLabel = 'editorLeftContactFooterImageLabel',
  editorLeftPageConfigTitle = 'editorLeftPageConfigTitle',
  editorLeftPageConfigWebsiteBackgroundLabel = 'editorLeftPageConfigWebsiteBackgroundLabel',
  editorLeftPageConfigWebsiteBackgroundDescription = 'editorLeftPageConfigWebsiteBackgroundDescription',
  editorLeftPageConfigPageMaxWidthLabel = 'editorLeftPageConfigPageMaxWidthLabel',
  editorLeftPageConfigPageMaxWidthDescription = 'editorLeftPageConfigPageMaxWidthDescription',
  editorLeftPageConfigPageContentAnimationLabel = 'editorLeftPageConfigPageContentAnimationLabel',
  editorLeftPageConfigPageContentAnimationDescription = 'editorLeftPageConfigPageContentAnimationDescription',
  editorBackgroundColorOptionStandard = 'editorBackgroundColorOptionStandard',
  editorBackgroundColorOptionWhite = 'editorBackgroundColorOptionWhite',
  editorBackgroundColorOptionOffWhite = 'editorBackgroundColorOptionOffWhite',
  editorLeftPageConfigPageMaxWidthOptionNormal = 'editorLeftPageConfigPageMaxWidthOptionNormal',
  editorLeftPageConfigPageMaxWidthOptionWide = 'editorLeftPageConfigPageMaxWidthOptionWide',
  editorLeftPageConfigPageContentAnimationOptionNone = 'editorLeftPageConfigPageContentAnimationOptionNone',
  editorLeftPageConfigPageContentAnimationOptionFadeBottom = 'editorLeftPageConfigPageContentAnimationOptionFadeBottom',
  editorLeftSelectFooterPlaceholder = 'editorLeftSelectFooterPlaceholder',
  editorLeftSelectNavPlaceholder = 'editorLeftSelectNavPlaceholder',
  editorLeftSelectFontPlaceholder = 'editorLeftSelectFontPlaceholder',
  editorPageFormPageNameMissing = 'editorPageFormPageNameMissing',
  editorPageFormPageNameReserved = 'editorPageFormPageNameReserved',
  editorPageFormPage = 'editorPageFormPage',
  editorPageFormPageNameLabel = 'editorPageFormPageNameLabel',
  editorPageFormPageNameDescription = 'editorPageFormPageNameDescription',
  editorPageFormAuthOnlyLabel = 'editorPageFormAuthOnlyLabel',
  editorPageFormAuthOnlyDescription = 'editorPageFormAuthOnlyDescription',
  editorSitemapTopLevel = 'editorSitemapTopLevel',
  editorSitemapEditing = 'editorSitemapEditing',
  editorSitemapEditingTooltip = 'editorSitemapEditingTooltip',
  editorSitemapBackTo = 'editorSitemapBackTo',
  editorSitemapNoPages = 'editorSitemapNoPages',
  editorSitemapAddPage = 'editorSitemapAddPage',
  editorTopPreviewMobile = 'editorTopPreviewMobile',
  editorTopPreviewDesktop = 'editorTopPreviewDesktop',
  editorTopSaved = 'editorTopSaved',
  editorTopPublished = 'editorTopPublished',
  editorTopPublishing = 'editorTopPublishing',
  editorTopPublish = 'editorTopPublish',
  editorTopBack = 'editorTopBack',
  editorNoPageSelected = 'editorNoPageSelected',
  editorEditingPage = 'editorEditingPage',
  editorPressEscapeToLeaveFullscreen = 'editorPressEscapeToLeaveFullscreen',
  editorRemovePageConfirmationTitle = 'editorRemovePageConfirmationTitle',
  editorRemovePageConfirmationText = 'editorRemovePageConfirmationText',
  editorUnsavedChangesMessage = 'editorUnsavedChangesMessage',
  editorUnsavedChangesTitle = 'editorUnsavedChangesTitle',
  editorUnsavedChangesProceed = 'editorUnsavedChangesProceed',
  editorUnsavedChangesAbort = 'editorUnsavedChangesAbort',
  editorRightEditingTooltip = 'editorRightEditingTooltip',

  // Content type editors
  textSettings = 'textSettings',
  marginOptionsTitle = 'marginOptionsTitle',
  marginOptionsTopLabel = 'marginOptionsTopLabel',
  marginOptionsTopDescription = 'marginOptionsTopDescription',
  marginOptionsBottomLabel = 'marginOptionsBottomLabel',
  marginOptionsBottomDescription = 'marginOptionsBottomDescription',
  marginOptionsPlaceholder = 'marginOptionsPlaceholder',

  textAlignmentLabel = 'textAlignmentLabel',
  textAlignmentDescription = 'textAlignmentDescription',
  textAlignmentOptionLeft = 'textAlignmentOptionLeft',
  textAlignmentOptionRight = 'textAlignmentOptionRight',
  textAlignmentOptionCenter = 'textAlignmentOptionCenter',
  textAlignmentOptionCenterMobile = 'textAlignmentOptionCenterMobile',

  fontWeightLabel = 'fontWeightLabel',
  fontWeightDescription = 'fontWeightDescription',
  fontWeightOptionThin = 'fontWeightOptionThin',
  fontWeightOptionExtralight = 'fontWeightOptionExtralight',
  fontWeightOptionLight = 'fontWeightOptionLight',
  fontWeightOptionNormal = 'fontWeightOptionNormal',
  fontWeightOptionMedium = 'fontWeightOptionMedium',
  fontWeightOptionSemibold = 'fontWeightOptionSemibold',
  fontWeightOptionBold = 'fontWeightOptionBold',
  fontWeightOptionExtrabold = 'fontWeightOptionExtrabold',
  fontWeightOptionBlack = 'fontWeightOptionBlack',

  textColorLabel = 'textColorLabel',
  textColorDescription = 'textColorDescription',
  textColorOptionBlack = 'textColorOptionBlack',
  textColorOptionWhite = 'textColorOptionWhite',
  textColorOptionNeutral700 = 'textColorOptionNeutral700',
  textColorOptionPrimary400 = 'textColorOptionPrimary400',
  textColorOptionPrimary300 = 'textColorOptionPrimary300',
  textColorOptionPrimary200 = 'textColorOptionPrimary200',

  fontSizeLabel = 'fontSizeLabel',
  fontSizeDescription = 'fontSizeDescription',

  leadingLabel = 'leadingLabel',
  leadingDescription = 'leadingDescription',

  textMaxWidthLabel = 'textMaxWidthLabel',
  textMaxWidthDescription = 'textMaxWidthDescription',
  textMaxWidthOptionNone = 'textMaxWidthOptionNone',

  gridEditorLayoutLabel = 'gridEditorLayoutLabel',
  gridEditorLayoutDescription = 'gridEditorLayoutDescription',
  gridEditorLayoutPlaceholder = 'gridEditorLayoutPlaceholder',
  gridEditorLayoutFullWidth = 'gridEditorLayoutFullWidth',
  gridEditorGapLabel = 'gridEditorGapLabel',
  gridEditorGapDescription = 'gridEditorGapDescription',
  gridEditorDirectionLabel = 'gridEditorDirectionLabel',
  gridEditorDirectionDescription = 'gridEditorDirectionDescription',
  gridEditorDirectionLeftLabel = 'gridEditorDirectionLeftLabel',
  gridEditorDirectionRightLabel = 'gridEditorDirectionRightLabel',
  gridEditorTopLineLabel = 'gridEditorTopLineLabel',
  gridEditorTopLineDescription = 'gridEditorTopLineDescription',
  gridEditorBottomLineLabel = 'gridEditorBottomLineLabel',
  gridEditorBottomLineDescription = 'gridEditorBottomLineDescription',
  gridEditorBackgroundLabel = 'gridEditorBackgroundLabel',
  gridEditorBackgroundOptionNone = 'gridEditorBackgroundOptionNone',
  gridEditorBackgroundOptionPrimary = 'gridEditorBackgroundOptionPrimary',
  gridEditorBackgroundOptionAccent = 'gridEditorBackgroundOptionAccent',

  headerEditorTextLabel = 'headerEditorTextLabel',
  headerEditorTextPlaceholder = 'headerEditorTextPlaceholder',

  imageCardsEditorCard = 'imageCardsEditorCard',
  imageCardsEditorHeader = 'imageCardsEditorHeader',
  imageCardsEditorParagraph = 'imageCardsEditorParagraph',
  imageCardsEditorButtonText = 'imageCardsEditorButtonText',
  imageCardsEditorButtonLink = 'imageCardsEditorButtonLink',

  bulletPointsEditorRow = 'bulletPointsEditorRow',
  bulletPointsEditorText = 'bulletPointsEditorText',

  svgInputLabel = 'svgInputLabel',
  svgInputPlaceholder = 'svgInputPlaceholder',

  logoSectionEditorLogo = 'logoSectionEditorLogo',
  logoSectionEditorCompanyName = 'logoSectionEditorCompanyName',
  logoSectionEditorLink = 'logoSectionEditorLink',

  imageCollageEditorMainImage = 'imageCollageEditorMainImage',
  imageCollageEditorSecondaryImage = 'imageCollageEditorSecondaryImage',
  imageCollageEditorSettingsTitle = 'imageCollageEditorSettingsTitle',
  imageCollageEditorLayoutLabel = 'imageCollageEditorLayoutLabel',
  imageCollageEditorLayoutDescription = 'imageCollageEditorLayoutDescription',
  imageCollageEditorLayoutOptionBottomLeft = 'imageCollageEditorLayoutOptionBottomLeft',
  imageCollageEditorLayoutOptionBottomRight = 'imageCollageEditorLayoutOptionBottomRight',

  imageOptionsRoundedLabel = 'imageOptionsRoundedLabel',
  imageOptionsRoundedDescription = 'imageOptionsRoundedDescription',
  imageOptionsRoundedOptionNone = 'imageOptionsRoundedOptionNone',
  imageOptionsRoundedOptionMedium = 'imageOptionsRoundedOptionMedium',
  imageOptionsRoundedOptionXLarge = 'imageOptionsRoundedOptionXLarge',
  imageOptionsShadowLabel = 'imageOptionsShadowLabel',
  imageOptionsShadowDescription = 'imageOptionsShadowDescription',
  imageOptionsShadowOptionNone = 'imageOptionsShadowOptionNone',
  imageOptionsShadowOptionMedium = 'imageOptionsShadowOptionMedium',
  imageOptionsShadowOptionXLarge = 'imageOptionsShadowOptionXLarge',

  serviceCardEditorHeaderLabel = 'serviceCardEditorHeaderLabel',
  serviceCardEditorHeaderPlaceholder = 'serviceCardEditorHeaderPlaceholder',
  serviceCardEditorButtonTextLabel = 'serviceCardEditorButtonTextLabel',
  serviceCardEditorButtonTextPlaceholder = 'serviceCardEditorButtonTextPlaceholder',
  serviceCardEditorButtonLinkLabel = 'serviceCardEditorButtonLinkLabel',
  serviceCardEditorButtonLinkPlaceholder = 'serviceCardEditorButtonLinkPlaceholder',

  buttonEditorButtonTextLabel = 'buttonEditorButtonTextLabel',
  buttonEditorButtonTextPlaceholder = 'buttonEditorButtonTextPlaceholder',
  buttonEditorButtonLinkLabel = 'buttonEditorButtonLinkLabel',
  buttonEditorButtonLinkPlaceholder = 'buttonEditorButtonLinkPlaceholder',
  buttonEditorButtonLinkDescription = 'buttonEditorButtonLinkDescription',
  buttonEditorButtonSettingsTitle = 'buttonEditorButtonSettingsTitle',
  buttonEditorColorLabel = 'buttonEditorColorLabel',
  buttonEditorColorDescription = 'buttonEditorColorDescription',
  buttonEditorColorOptionCustomer = 'buttonEditorColorOptionCustomer',
  buttonEditorColorOptionAccent = 'buttonEditorColorOptionAccent',
  buttonEditorColorOptionDark = 'buttonEditorColorOptionDark',
  buttonEditorColorOptionLight = 'buttonEditorColorOptionLight',
  buttonEditorTypeLabel = 'buttonEditorTypeLabel',
  buttonEditorTypeDescription = 'buttonEditorTypeDescription',
  buttonEditorTypeOptionFilled = 'buttonEditorTypeOptionFilled',
  buttonEditorTypeOptionOutline = 'buttonEditorTypeOptionOutline',

  imageEditorImageLabel = 'imageEditorImageLabel',
  imageEditorImageTextLabel = 'imageEditorImageTextLabel',
  imageEditorImageTextDescription = 'imageEditorImageTextDescription',
  imageEditorImageSettingsTitle = 'imageEditorImageSettingsTitle',

  galleryEditorAddImage = 'galleryEditorAddImage',
  galleryEditorImageSettingsTitle = 'galleryEditorImageSettingsTitle',

  formEditorNewField = 'formEditorNewField',
  formEditorContactEmailLabel = 'formEditorContactEmailLabel',
  formEditorContactEmailDescription = 'formEditorContactEmailDescription',
  formEditorSubmitTextLabel = 'formEditorSubmitTextLabel',
  formEditorSubmitTextDescription = 'formEditorSubmitTextDescription',
  formEditorSuccessTextLabel = 'formEditorSuccessTextLabel',
  formEditorSuccessTextDescription = 'formEditorSuccessTextDescription',
  formEditorSenderConfirmationEmailSubjectLabel = 'formEditorSenderConfirmationEmailSubjectLabel',
  formEditorSenderConfirmationEmailSubjectDescription = 'formEditorSenderConfirmationEmailSubjectDescription',
  formEditorSenderConfirmationEmailBodyLabel = 'formEditorSenderConfirmationEmailBodyLabel',
  formEditorSenderConfirmationEmailBodyDescription = 'formEditorSenderConfirmationEmailBodyDescription',
  formEditorSenderConfirmationEmailImageLabel = 'formEditorSenderConfirmationEmailImageLabel',
  formEditorSenderConfirmationEmailImageDescription = 'formEditorSenderConfirmationEmailImageDescription',
  formEditorFieldsTitle = 'formEditorFieldsTitle',
  formEditorFieldNameLabel = 'formEditorFieldNameLabel',
  formEditorRequiredLabel = 'formEditorRequiredLabel',
  formEditorFieldTypePlaceholder = 'formEditorFieldTypePlaceholder',
  formEditorFieldTypeOptionText = 'formEditorFieldTypeOptionText',
  formEditorFieldTypeOptionTextarea = 'formEditorFieldTypeOptionTextarea',
  formEditorFieldTypeOptionEmail = 'formEditorFieldTypeOptionEmail',
  formEditorFieldTypeOptionTel = 'formEditorFieldTypeOptionTel',
  formEditorFieldWidthPlaceholder = 'formEditorFieldWidthPlaceholder',
  formEditorFieldWidthOptionFull = 'formEditorFieldWidthOptionFull',
  formEditorFieldWidthOptionHalf = 'formEditorFieldWidthOptionHalf',
  formEditorAddField = 'formEditorAddField',

  videoHeroEditorContentTitle = 'videoHeroEditorContentTitle',
  videoHeroEditorHeaderTextLabel = 'videoHeroEditorHeaderTextLabel',
  videoHeroEditorHeaderTextPlaceholder = 'videoHeroEditorHeaderTextPlaceholder',
  videoHeroEditorHeaderTextDescription = 'videoHeroEditorHeaderTextDescription',
  videoHeroEditorParagraphTextLabel = 'videoHeroEditorParagraphTextLabel',
  videoHeroEditorParagraphTextPlaceholder = 'videoHeroEditorParagraphTextPlaceholder',
  videoHeroEditorParagraphTextDescription = 'videoHeroEditorParagraphTextDescription',
  videoHeroEditorCtaTextLabel = 'videoHeroEditorCtaTextLabel',
  videoHeroEditorCtaTextPlaceholder = 'videoHeroEditorCtaTextPlaceholder',
  videoHeroEditorCtaTextDescription = 'videoHeroEditorCtaTextDescription',
  videoHeroEditorCtaLinkLabel = 'videoHeroEditorCtaLinkLabel',
  videoHeroEditorCtaLinkPlaceholder = 'videoHeroEditorCtaLinkPlaceholder',
  videoHeroEditorCtaLinkDescription = 'videoHeroEditorCtaLinkDescription',
  videoHeroEditorOverlayPercentageLabel = 'videoHeroEditorOverlayPercentageLabel',
  videoHeroEditorOverlayPercentageDescription = 'videoHeroEditorOverlayPercentageDescription',
  videoHeroEditorOverlayPercentageOptionNone = 'videoHeroEditorOverlayPercentageOptionNone',
  videoHeroEditorVideoTitle = 'videoHeroEditorVideoTitle',
  videoHeroEditorNoVideoSelected = 'videoHeroEditorNoVideoSelected',
  videoHeroEditorChangeVideo = 'videoHeroEditorChangeVideo',
  videoHeroEditorSelectVideo = 'videoHeroEditorSelectVideo',

  topSectionEditorHeaderTextLabel = 'topSectionEditorHeaderTextLabel',
  topSectionEditorHeaderTextPlaceholder = 'topSectionEditorHeaderTextPlaceholder',
  topSectionEditorHeaderTextDescription = 'topSectionEditorHeaderTextDescription',
  topSectionEditorAccentTitle = 'topSectionEditorAccentTitle',
  topSectionEditorAccentLabel = 'topSectionEditorAccentLabel',
  topSectionEditorAccentDescription = 'topSectionEditorAccentDescription',
  topSectionEditorAccentPlaceholder = 'topSectionEditorAccentPlaceholder',
  topSectionEditorParagraphTextLabel = 'topSectionEditorParagraphTextLabel',
  topSectionEditorParagraphTextPlaceholder = 'topSectionEditorParagraphTextPlaceholder',
  topSectionEditorParagraphTextDescription = 'topSectionEditorParagraphTextDescription',
  topSectionEditorCtaTextLabel = 'topSectionEditorCtaTextLabel',
  topSectionEditorCtaTextPlaceholder = 'topSectionEditorCtaTextPlaceholder',
  topSectionEditorCtaTextDescription = 'topSectionEditorCtaTextDescription',
  topSectionEditorCtaLinkLabel = 'topSectionEditorCtaLinkLabel',
  topSectionEditorCtaLinkPlaceholder = 'topSectionEditorCtaLinkPlaceholder',
  topSectionEditorCtaLinkDescription = 'topSectionEditorCtaLinkDescription',
  topSectionEditorCtaColorLabel = 'topSectionEditorCtaColorLabel',
  topSectionEditorCtaColorDescription = 'topSectionEditorCtaColorDescription',
  topSectionCtaColorOptionPrimary = 'topSectionCtaColorOptionPrimary',
  topSectionCtaColorOptionAccent = 'topSectionCtaColorOptionAccent',
  topSectionEditorOverlayTitle = 'topSectionEditorOverlayTitle',
  topSectionEditorOverlayColorLabel = 'topSectionEditorOverlayColorLabel',
  topSectionEditorOverlayColorDescription = 'topSectionEditorOverlayColorDescription',
  topSectionEditorOverlayColorPlaceholder = 'topSectionEditorOverlayColorPlaceholder',
  topSectionOverlayColorOptionWhite = 'topSectionOverlayColorOptionWhite',
  topSectionOverlayColorOptionGray200 = 'topSectionOverlayColorOptionGray200',
  topSectionOverlayColorOptionGray400 = 'topSectionOverlayColorOptionGray400',
  topSectionOverlayColorOptionGray600 = 'topSectionOverlayColorOptionGray600',
  topSectionOverlayColorOptionBlack = 'topSectionOverlayColorOptionBlack',
  topSectionEditorOverlayStrengthLabel = 'topSectionEditorOverlayStrengthLabel',
  topSectionEditorOverlayStrengthDescription = 'topSectionEditorOverlayStrengthDescription',
  topSectionEditorOverlayStrengthPlaceholder = 'topSectionEditorOverlayStrengthPlaceholder',
  topSectionOverlayStrengthOption02 = 'topSectionOverlayStrengthOption02',
  topSectionOverlayStrengthOption05 = 'topSectionOverlayStrengthOption05',
  topSectionOverlayStrengthOption07 = 'topSectionOverlayStrengthOption07',
  topSectionOverlayStrengthOption1 = 'topSectionOverlayStrengthOption1',
  topSectionEditorImageCarouselTitle = 'topSectionEditorImageCarouselTitle',
  topSectionEditorImageCarouselLabel = 'topSectionEditorImageCarouselLabel',
  topSectionEditorImageCarouselDescription = 'topSectionEditorImageCarouselDescription',
  topSectionEditorImageCarouselAddImage = 'topSectionEditorImageCarouselAddImage',
  topSectionEditorHeightLabel = 'topSectionEditorHeightLabel',
  topSectionEditorHeightDescription = 'topSectionEditorHeightDescription',
  topSectionEditorHeightPlaceholder = 'topSectionEditorHeightPlaceholder',
  topSectionEditorHeightOptionLow = 'topSectionEditorHeightOptionLow',
  topSectionEditorHeightOptionMedium = 'topSectionEditorHeightOptionMedium',
  topSectionEditorHeightOptionHigh = 'topSectionEditorHeightOptionHigh',
  topSectionEditorMarginBottomLabel = 'topSectionEditorMarginBottomLabel',
  topSectionEditorMarginBottomDescription = 'topSectionEditorMarginBottomDescription',
  topSectionEditorMarginBottomPlaceholder = 'topSectionEditorMarginBottomPlaceholder',

  quickLinksEditorMyLink = 'quickLinksEditorMyLink',
  quickLinksEditorLink = 'quickLinksEditorLink',
  quickLinksEditorTextLabel = 'quickLinksEditorTextLabel',
  quickLinksEditorTextDescription = 'quickLinksEditorTextDescription',
  quickLinksEditorLinkLabel = 'quickLinksEditorLinkLabel',
  quickLinksEditorLinkDescription = 'quickLinksEditorLinkDescription',
  quickLinksEditorLinkPlaceholder = 'quickLinksEditorLinkPlaceholder',
  quickLinksEditorLinkRemove = 'quickLinksEditorLinkRemove',
  quickLinksEditorLinkAdd = 'quickLinksEditorLinkAdd',
  quickLinksEditorColorLabel = 'quickLinksEditorColorLabel',
  quickLinksEditorColorOptionWhite = 'quickLinksEditorColorOptionWhite',
  quickLinksEditorColorOptionPrimary = 'quickLinksEditorColorOptionPrimary',
  quickLinksEditorColorOptionAccent = 'quickLinksEditorColorOptionAccent',

  accordionEditorTitleLabel = 'accordionEditorTitleLabel',
  accordionEditorTitleDescription = 'accordionEditorTitleDescription',
  accordionEditorContentLabel = 'accordionEditorContentLabel',
  accordionEditorMarginBottomLabel = 'accordionEditorMarginBottomLabel',
  accordionEditorMarginBottomDescription = 'accordionEditorMarginBottomDescription',
  accordionEditorMarginBottomPlaceholder = 'accordionEditorMarginBottomPlaceholder',

  tipsBoxEditorTextLabel = 'tipsBoxEditorTextLabel',
  tipsBoxEditorMarginBottomLabel = 'tipsBoxEditorMarginBottomLabel',
  tipsBoxEditorMarginBottomDescription = 'tipsBoxEditorMarginBottomDescription',
  tipsBoxEditorMarginBottomPlaceholder = 'tipsBoxEditorMarginBottomPlaceholder',
  tipsBoxEditorAlignmentLabel = 'tipsBoxEditorAlignmentLabel',
  tipsBoxEditorAlignmentPlaceholder = 'tipsBoxEditorAlignmentPlaceholder',
  tipsBoxEditorAlignmentOptionLeft = 'tipsBoxEditorAlignmentOptionLeft',
  tipsBoxEditorAlignmentOptionCenter = 'tipsBoxEditorAlignmentOptionCenter',

  documentEditorButtonTextLabel = 'documentEditorButtonTextLabel',
  documentEditorButtonTextDescription = 'documentEditorButtonTextDescription',
  documentEditorButtonTextPlaceholder = 'documentEditorButtonTextPlaceholder',
  documentEditorDocumentLabel = 'documentEditorDocumentLabel',
  documentEditorNoDocumentSelected = 'documentEditorNoDocumentSelected',
  documentEditorChangeDocument = 'documentEditorChangeDocument',
  documentEditorSelectDocument = 'documentEditorSelectDocument',
  documentEditorMarginBottomLabel = 'documentEditorMarginBottomLabel',
  documentEditorMarginBottomDescription = 'documentEditorMarginBottomDescription',
  documentEditorMarginBottomPlaceholder = 'documentEditorMarginBottomPlaceholder',

  blogEditorMarginBottomLabel = 'blogEditorMarginBottomLabel',
  blogEditorMarginBottomDescription = 'blogEditorMarginBottomDescription',
  blogEditorMarginBottomPlaceholder = 'blogEditorMarginBottomPlaceholder',

  calendarEditorMarginBottomLabel = 'calendarEditorMarginBottomLabel',
  calendarEditorMarginBottomDescription = 'calendarEditorMarginBottomDescription',
  calendarEditorMarginBottomPlaceholder = 'calendarEditorMarginBottomPlaceholder',

  contactFormEditorHeaderLabel = 'contactFormEditorHeaderLabel',
  contactFormEditorHeaderDescription = 'contactFormEditorHeaderDescription',
  contactFormEditorInstructionLabel = 'contactFormEditorInstructionLabel',
  contactFormEditorInstructionDescription = 'contactFormEditorInstructionDescription',
  contactFormEditorInstructionPlaceholder = 'contactFormEditorInstructionPlaceholder',
  contactFormEditorResponseEmailLabel = 'contactFormEditorResponseEmailLabel',
  contactFormEditorResponseEmailDescription = 'contactFormEditorResponseEmailDescription',
  contactFormEditorResponseEmailPlaceholder = 'contactFormEditorResponseEmailPlaceholder',
  contactFormEditorMarginBottomLabel = 'contactFormEditorMarginBottomLabel',
  contactFormEditorMarginBottomDescription = 'contactFormEditorMarginBottomDescription',
  contactFormEditorMarginBottomPlaceholder = 'contactFormEditorMarginBottomPlaceholder',

  sponsorEditorTopTextLabel = 'sponsorEditorTopTextLabel',

  ytVideoEditorUrlLabel = 'ytVideoEditorUrlLabel',
  ytVideoEditorUrlDescription = 'ytVideoEditorUrlDescription',
  ytVideoEditorMarginBottomLabel = 'ytVideoEditorMarginBottomLabel',
  ytVideoEditorMarginBottomDescription = 'ytVideoEditorMarginBottomDescription',
  ytVideoEditorMarginBottomPlaceholder = 'ytVideoEditorMarginBottomPlaceholder',

  foodMenuEditorItemsTitle = 'foodMenuEditorItemsTitle',
  foodMenuEditorItemsTitleLabel = 'foodMenuEditorItemsTitleLabel',
  foodMenuEditorItemsTitleDescription = 'foodMenuEditorItemsTitleDescription',
  foodMenuEditorItemsPriceLabel = 'foodMenuEditorItemsPriceLabel',
  foodMenuEditorItemsPriceDescription = 'foodMenuEditorItemsPriceDescription',
  foodMenuEditorItemsDescriptionLabel = 'foodMenuEditorItemsDescriptionLabel',
  foodMenuEditorItemsDescriptionDescription = 'foodMenuEditorItemsDescriptionDescription',
  foodMenuEditorItemsCategoryLabel = 'foodMenuEditorItemsCategoryLabel',
  foodMenuEditorItemsCategoryDescription = 'foodMenuEditorItemsCategoryDescription',

  // Content types
  contentTypeAccordion = 'contentTypeAccordion',
  contentTypeBlog = 'contentTypeBlog',
  contentTypeBullets = 'contentTypeBullets',
  contentTypeGallery = 'contentTypeGallery',
  contentTypeButton = 'contentTypeButton',
  contentTypeForm = 'contentTypeForm',
  contentTypeGrid = 'contentTypeGrid',
  contentTypeHeader = 'contentTypeHeader',
  contentTypeImage = 'contentTypeImage',
  contentTypeRichtext = 'contentTypeRichtext',
  contentTypeDocument = 'contentTypeDocument',
  contentTypeSponsors = 'contentTypeSponsors',
  contentTypeTipsbox = 'contentTypeTipsbox',
  contentTypeCalendar = 'contentTypeCalendar',
  contentTypeContactform = 'contentTypeContactform',
  contentTypeQuicklinks = 'contentTypeQuicklinks',
  contentTypeYtvideo = 'contentTypeYtvideo',
  contentTypeTopsection = 'contentTypeTopsection',
  contentTypeVideoHero = 'contentTypeVideoHero',
  contentTypeImageCards = 'contentTypeImageCards',
  contentTypeImageCollage = 'contentTypeImageCollage',
  contentTypeLogoSection = 'contentTypeLogoSection',
  contentTypeServiceCard = 'contentTypeServiceCard',
  contentTypeDSolutionsBadge = 'contentTypeDSolutionsBadge',
  contentTypeFoodMenu = 'contentTypeFoodMenu',
  contentTypeOpeningHours = 'contentTypeOpeningHours',

  // Editor center
  editorCenterNoPageSelected = 'editorCenterNoPageSelected',
  editorCenterSelectPage = 'editorCenterSelectPage',
  editorCenterMoveSectionUp = 'editorCenterMoveSectionUp',
  editorCenterMoveSectionDown = 'editorCenterMoveSectionDown',
  editorCenterAddSectionAbove = 'editorCenterAddSectionAbove',
  editorCenterAddSectionBelow = 'editorCenterAddSectionBelow',
  editorCenterEditSection = 'editorCenterEditSection',
  editorCenterDroppableText = 'editorCenterDroppableText',
  editorCenterDroppableHoverText = 'editorCenterDroppableHoverText',

  // CMS Editor
  cmsEditorLeftHeader = 'cmsEditorLeftHeader',
  cmsEditorCenterHeader = 'cmsEditorCenterHeader',
  cmsEditorNoActiveEntry = 'cmsEditorNoActiveEntry',

  // Ecommerce
  ecommerceRouteTitle = 'ecommerceRouteTitle',
}
